<template>
    <!-- fixed to the caret, so it opens under what is being typed rather than over it -->
    <div
        class="bo-variable-suggest"
        :style="position"
        @mousemove="highlightUnderPointer"
    >
        <div
            v-for="(item, index) in items"
            :key="item.id"
            class="bo-variable-suggest__item"
            :class="{ active: index === activeIndex }"
            :data-index="index"
            @mousedown.prevent="select(item)"
        >
            {{ item.label }}
        </div>
    </div>
</template>

<script>
export default {
    name: "bo-variable-suggest",
    props: {
        items: {
            type: Array,
            default: () => [],
        },
        // caret rect (viewport coordinates) from the editing surface - { left, bottom }
        rect: {
            type: Object,
            default: null,
        },
        activeIndex: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            pointerX: null,
            pointerY: null,
        };
    },
    computed: {
        position() {
            if (!this.rect) {
                return {};
            }

            // keep the list inside the viewport when the caret nears the right edge
            const width = this.$el?.offsetWidth || 180;
            const margin = 8;
            const left = Math.max(margin, Math.min(this.rect.left, window.innerWidth - width - margin));

            return {
                top: `${this.rect.bottom + 4}px`,
                left: `${left}px`,
            };
        },
    },
    watch: {
        // the keyboard can move the active row past the scroll fold
        activeIndex() {
            this.$nextTick(() => this.scrollActiveIntoView());
        },
    },
    methods: {
        // The highlight follows the pointer only while it is actually moving. Reading mouseenter
        // instead would let a row reset the highlight just because it slid under a still cursor -
        // e.g. when the list scrolls itself during arrow-key navigation. Browsers can also emit a
        // mousemove at unchanged coordinates when the element under the cursor changes, hence the
        // coordinate check.
        highlightUnderPointer(event) {
            if (event.clientX === this.pointerX && event.clientY === this.pointerY) {
                return;
            }

            this.pointerX = event.clientX;
            this.pointerY = event.clientY;

            const item = event.target.closest?.(".bo-variable-suggest__item");

            if (item) {
                this.$emit("move", Number(item.dataset.index));
            }
        },
        // scroll only this list - scrollIntoView would also scroll the page it sits on
        scrollActiveIntoView() {
            const list = this.$el;
            const item = list?.children?.[this.activeIndex];

            if (!list || !item) {
                return;
            }

            const top = item.offsetTop;
            const bottom = top + item.offsetHeight;

            if (top < list.scrollTop) {
                list.scrollTop = top;
            } else if (bottom > list.scrollTop + list.clientHeight) {
                list.scrollTop = bottom - list.clientHeight;
            }
        },
        select(item) {
            this.$emit("select", item);
        },
    },
};
</script>
